import { render } from "./PdShow.vue?vue&type=template&id=0960f021"
import script from "./PdShow.vue?vue&type=script&lang=js"
export * from "./PdShow.vue?vue&type=script&lang=js"

import "./PdShow.vue?vue&type=style&index=0&id=0960f021&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__